import React, { useState } from 'react';

type Metric = 'bookings' | 'inquiries';

const CHANNELS = [
  { name: 'Instagram', bookings: 6, inquiries: 14, color: '#0f7f86' },
  { name: 'Google Search', bookings: 3, inquiries: 8, color: '#d29a38' },
  { name: 'Referral', bookings: 1, inquiries: 4, color: '#8a72ba' },
] as const;

/** A clearly labeled example of the cross-app answer a business owner can ask for. */
const MarketingDemo: React.FC = () => {
  const [metric, setMetric] = useState<Metric>('bookings');
  const total = CHANNELS.reduce((sum, channel) => sum + channel[metric], 0);
  const highest = Math.max(...CHANNELS.map((channel) => channel[metric]));

  return (
    <div className="marketing-demo" aria-label="Illustrative Arceus conversation and source chart for a med spa">
      <div className="marketing-demo__top">
        <span className="marketing-demo__eyebrow">Illustrative example · med spa</span>
        <span className="marketing-demo__status">Connected view</span>
      </div>

      <div className="marketing-demo__question">
        <span>Owner asks</span>
        <strong>“Which ad brought in my last ten consults?”</strong>
      </div>

      <div className="marketing-demo__connectors" aria-label="Example connected sources">
        <span>Meta Ads</span><span>Google Ads</span><span>Calendar</span><span>Call log</span>
      </div>

      <div className="marketing-demo__answer">
        <div className="marketing-demo__answer-head"><span className="marketing-demo__avatar">A</span><b>Arceus</b></div>
        <p>Six booked from Instagram, three from Google Search, and one came by referral. Here is the breakdown.</p>

        <div className="marketing-demo__chart">
          <div className="marketing-demo__chart-head">
            <div><small>Example source report</small><strong>{total} {metric === 'bookings' ? 'booked consults' : 'inquiries'}</strong></div>
            <div className="marketing-demo__toggle" aria-label="Chart metric">
              <button type="button" className={metric === 'bookings' ? 'is-active' : ''} aria-pressed={metric === 'bookings'} onClick={() => setMetric('bookings')}>Bookings</button>
              <button type="button" className={metric === 'inquiries' ? 'is-active' : ''} aria-pressed={metric === 'inquiries'} onClick={() => setMetric('inquiries')}>Inquiries</button>
            </div>
          </div>
          <div className="marketing-demo__bars">
            {CHANNELS.map((channel) => (
              <div className="marketing-demo__bar-row" key={channel.name}>
                <span>{channel.name}</span>
                <div className="marketing-demo__track"><i style={{ width: `${(channel[metric] / highest) * 100}%`, backgroundColor: channel.color }} /></div>
                <b>{channel[metric]}</b>
              </div>
            ))}
          </div>
        </div>

        <div className="marketing-demo__next"><span>Suggested next step</span><strong>Put more of next week’s budget toward the ad that booked six. You approve the change.</strong></div>
      </div>
    </div>
  );
};

export default React.memo(MarketingDemo);
